// extracted by mini-css-extract-plugin
export default {"root":"ShipmentDetailsBlockSkeleton_root__N6LMP"};